import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CreateCharacter from './CreateCharacter';
import EditCharacter from './EditCharacter';

function CharactersTab({ loadingBarRef }) {
    const { t } = useTranslation();
    return (
        <Tabs defaultActiveKey="create" id="characters-tabs">
            <Tab eventKey="create" title={t('characters.createTab')}>
                <CreateCharacter loadingBarRef={loadingBarRef} />
            </Tab>
            <Tab eventKey="edit" title={t('characters.editTab')}>
                <EditCharacter loadingBarRef={loadingBarRef} />
            </Tab>
        </Tabs>
    );
}

export default CharactersTab;